module.exports = __webpack_public_path__ + "static/media/phone.43bb888.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videoBg/RoundMove/phone.mp4
// module id = N4mA
// module chunks = 1